
































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { StatusModel, StatusItemModel } from '@/model/charactersheets';
import { Dice } from '../../../module/dice';
import { DamageBonus } from '../../../module/damageBonus';
import { Build } from '../../../module/build';
import { Mov } from '../../../module/mov';
import Item from './item.vue';

@Component({
  components: { Item },
})
export default class Presentational extends Vue {
  @Prop() public statuses!: StatusModel;
  @Prop() public gamesystem!: number;

  @Emit() public update(value: StatusModel) {}

  @Watch('gamesystem')
  onGameSystemChanged() {
    this.calcStatus();
  }

  private get values(): StatusModel {
    return this.statuses;
  }

  private dbns(str, siz): string {
    return this.gamesystem === 0
      ? DamageBonus.calc6th(this.total(str), this.total(siz))
      : DamageBonus.calc7th(this.total(str) * 5, this.total(siz) * 5);
  }

  private total(payload: StatusItemModel): number {
    return payload.default + payload.correction;
  }

  public autoStatus() {
    const dice = new Dice();
    const value = {
      str: {
        default: dice.roll(3, 6).total,
        correction: this.values.str.correction,
      },
      con: {
        default: dice.roll(3, 6).total,
        correction: this.values.con.correction,
      },
      pow: {
        default: dice.roll(3, 6).total,
        correction: this.values.pow.correction,
      },
      dex: {
        default: dice.roll(3, 6).total,
        correction: this.values.dex.correction,
      },
      app: {
        default: dice.roll(3, 6).total,
        correction: this.values.app.correction,
      },
      siz: {
        default: dice.roll(2, 6).total + 6,
        correction: this.values.siz.correction,
      },
      int: {
        default: dice.roll(2, 6).total + 6,
        correction: this.values.int.correction,
      },
      edu: {
        default: dice.roll(3, 6).total + 3,
        correction: this.values.edu.correction,
      },
    };
    const calcValue = {
      luk: {
        default: (value.pow.default + value.pow.correction) * 5,
        correction: this.values.luk.correction,
      },
      idea: {
        default: (value.int.default + value.int.correction) * 5,
        correction: this.values.idea.correction,
      },
      knowledge: {
        default: (value.edu.default + value.edu.correction) * 5,
        correction: this.values.knowledge.correction,
      },
      san: {
        default: (value.pow.default + value.pow.correction) * 5,
        correction: this.values.san.correction,
      },
      hp: {
        default: Math.ceil((value.con.default + value.con.correction + (value.siz.default + value.siz.correction)) / 2),
        correction: this.values.hp.correction,
      },
      mp: {
        default: value.pow.default + value.pow.correction,
        correction: this.values.mp.correction,
      },
      dbns: this.dbns(value.str, value.siz),
      build: Build.calc(this.total(value.str) * 5, this.total(value.siz) * 5),
      mov: Mov.calc(this.total(value.str), this.total(value.dex), this.total(value.siz)),
    };
    this.update({ ...value, ...calcValue });
  }

  public calcStatus() {
    const conTotal = this.values.con.default + this.values.con.correction;
    const sizTotal = this.values.siz.default + this.values.siz.correction;
    const strTotal = this.values.str.default + this.values.str.correction;
    const calced = {
      luk: {
        default: (this.values.pow.default + this.values.pow.correction) * 5,
        correction: this.values.luk.correction,
      },
      idea: {
        default: (this.values.int.default + this.values.int.correction) * 5,
        correction: this.values.idea.correction,
      },
      knowledge: {
        default: (this.values.edu.default + this.values.edu.correction) * 5,
        correction: this.values.knowledge.correction,
      },
      san: {
        default: (this.values.pow.default + this.values.pow.correction) * 5,
        correction: this.values.san.correction,
      },
      hp: {
        default: Math.ceil((conTotal + sizTotal) / 2),
        correction: this.values.hp.correction,
      },
      mp: {
        default: this.values.pow.default + this.values.pow.correction,
        correction: this.values.mp.correction,
      },
      dbns: this.dbns(this.values.str, this.values.siz),
      build: Build.calc(this.total(this.values.str) * 5, this.total(this.values.siz) * 5),
      mov: Mov.calc(this.total(this.values.str), this.total(this.values.dex), this.total(this.values.siz)),
    };
    this.update({ ...this.values, ...calced });
  }
}
